import { render, staticRenderFns } from "./v-table.vue?vue&type=template&id=25a252a5"
import script from "./v-table.vue?vue&type=script&lang=js"
export * from "./v-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a252a5')) {
      api.createRecord('25a252a5', component.options)
    } else {
      api.reload('25a252a5', component.options)
    }
    module.hot.accept("./v-table.vue?vue&type=template&id=25a252a5", function () {
      api.rerender('25a252a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/table/v-table.vue"
export default component.exports